import { NOTIFICATION_DRAWER_FILTER } from '../const/notification-drawer-filter.const'
import type { Notification } from '../types/notification.type'
import type { NotificationDrawerFilter } from '../types/notification-drawer-filter.type'

export const filterNotificationsByReadState = (
  notifications: Notification[],
  filter: NotificationDrawerFilter
): Notification[] => {
  if (filter === NOTIFICATION_DRAWER_FILTER.UNREAD) {
    return notifications.filter((notification) => !notification.isRead)
  }

  return notifications
}
